import api from "../api";
import { PLAN_API_ENDPOINTS } from "../../constants/jewellery.constant";

// Helper function to replace path params
const replacePathParams = (path, params) => {
  let result = path;
  Object.keys(params).forEach((key) => {
    result = result.replace(`:${key}`, params[key]);
  });
  return result;
};

const planService = {
  // Create plan
  createPlan: async (planData) => {
    const response = await api.post(PLAN_API_ENDPOINTS.CREATE_PLAN, planData);
    return response.data;
  },

  // Get all plans
  getAllPlans: async (filters = {}) => {
    const response = await api.get(PLAN_API_ENDPOINTS.GET_ALL_PLANS, {
      params: filters,
    });
    return response.data;
  },

  // Get plan by ID
  getPlanById: async (planId) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.GET_PLAN_BY_ID, {
      id: planId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Get customer plans
  getCustomerPlans: async (userId, filters = {}) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.GET_CUSTOMER_PLANS, {
      userId,
    });
    const response = await api.get(url, { params: filters });
    return response.data;
  },

  // Get plan schedule
  getPlanSchedule: async (planId) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.GET_PLAN_SCHEDULE, {
      planId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Get plan ledger
  getPlanLedger: async (planId) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.GET_PLAN_LEDGER, {
      planId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Record payment for plan
  recordPlanPayment: async (planId, paymentData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.RECORD_PLAN_PAYMENT, {
      planId,
    });
    const response = await api.post(url, paymentData);
    return response.data;
  },

  // Create quote
  createQuote: async (planId, quoteData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.CREATE_QUOTE, {
      planId,
    });
    const response = await api.post(url, quoteData);
    return response.data;
  },

  // ==================== PAUSE FUNCTIONALITY ====================

  // Pause plan
  pausePlan: async (planId, pauseData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.PAUSE_PLAN, {
      planId,
    });
    const response = await api.post(url, pauseData);
    return response.data;
  },

  // Resume plan
  resumePlan: async (planId, resumeData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.RESUME_PLAN, {
      planId,
    });
    const response = await api.post(url, resumeData);
    return response.data;
  },

  // Get pause history
  getPauseHistory: async (planId) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.GET_PAUSE_HISTORY, {
      planId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Check pause eligibility
  checkPauseEligibility: async (planId) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.CHECK_PAUSE_ELIGIBILITY, {
      planId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Approve pause
  approvePause: async (pauseId, approvalData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.APPROVE_PAUSE, {
      pauseId,
    });
    const response = await api.patch(url, approvalData);
    return response.data;
  },

  // Reject pause (NEW)
  rejectPause: async (pauseId, rejectionData) => {
    const url = replacePathParams(PLAN_API_ENDPOINTS.REJECT_PAUSE, {
      pauseId,
    });
    const response = await api.post(url, rejectionData);
    return response.data;
  },

  // Get pending pause requests (NEW)
  getPendingPauseRequests: async (filters = {}) => {
    const response = await api.get(
      PLAN_API_ENDPOINTS.GET_PENDING_PAUSE_REQUESTS,
      { params: filters }
    );
    return response.data;
  },
};

export default planService;
